import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotEditableIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NotEditable",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.9 3c-.62-.62-1.48-1-2.43-1s-1.81.38-2.43 1l-1.56 1.56c-.27.27-.44.65-.44 1.06s.17.79.44 1.06l5.84 5.84c.27.27.65.44 1.06.44s.79-.17 1.06-.44L29 10.96c.62-.62 1-1.48 1-2.43s-.38-1.81-1-2.43l-3.09-3.09Zm-5.35 10.54.97-.97a1.498 1.498 0 0 0-1.06-2.56c-.42 0-.79.17-1.07.44l-.97.97zm2.99 2.98 1.04-1.05c.27-.27.43-.64.43-1.06 0-.83-.67-1.5-1.5-1.5-.42 0-.79.17-1.07.44l-1.03 1.04 2.12 2.12Zm-5.96-5.96.97-.97a1.498 1.498 0 1 0-2.12-2.12l-.97.97zm-3.15 10.88-2.92 2.92-.88-.88 2.92-2.92-2.11-2.11-2.92 2.92-.88-.88 2.92-2.92-2.12-2.12-4 4c-.12.12-.22.27-.29.43s-.05.14-.05.14 0 .09-.05.13l-2 8.01c-.03.11-.05.24-.05.37a1.498 1.498 0 0 0 1.88 1.45h-.01l8.01-2h.06l.25-.1.1-.05c.09-.05.16-.11.23-.18l3.98-4.01zM6.18 3.28l22.53 22.54c.38.37.62.89.62 1.46s-.24 1.09-.62 1.46c-.37.38-.89.62-1.46.62s-1.09-.24-1.46-.62L3.29 6.16c-.37-.37-.6-.89-.6-1.46 0-1.14.92-2.06 2.06-2.06.57 0 1.09.23 1.46.6z"
    })
  }));
};